import React from 'react';
import { useTranslation } from 'react-i18next';

export const ProjectsSection = ({ projectColumns }) => {
  const { t } = useTranslation();

  return (
    <div class="vb-content-normal">
      <div class="container vb-home-content vb-home-carousel-container">
        <div class="row vb-padding-mobile">
          <div class="col-lg-12">
            <h5 class="vb-about-subtitle-center">{t('home.projects.title')}</h5>
          </div>
        </div>
        <div class="vb-project-masonry">
          {projectColumns.map((columnProjects, columnIndex) => (
            <div
              class={`vb-project-masonry-column ${columnIndex === 1 ? 'vb-project-masonry-column--center' : 'vb-project-masonry-column--offset'}`}
              key={`project-col-${columnIndex}`}
            >
              {columnProjects.map((project) => (
                <div class="vb-project-masonry-item" key={project.title}>
                  <article class={`vb-project-card vb-project-card--${project.size}`}>
                    <div class="vb-project-card-media">
                      <img src={project.image} class="vb-project-card-image" alt={project.title}></img>
                    </div>
                    <div class="vb-project-card-body">
                      <h3 class="vb-project-card-title">{project.title}</h3>
                      <p class="vb-project-card-description">{project.description}</p>
                      <div class="vb-project-card-meta">
                        <span class="vb-project-card-location">{project.location}</span>
                      </div>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
